<app-datatable [sortArray]="[{prop: 'updated', dir: 'desc'}]"
    [service]="homepageService.getPersonasRelationshipEmployees" [defaultColumns]="defaultColumns"
    [columnsToExclude]="columnsToExclude" [section]="'relationship'" [subsection]="'employee'" [isMultiForm]="true" [columnsNotToFilter]="columnsNotToFilter">
</app-datatable>